import * as angular from "angular";

export class DataRecordService {
    private apiRoot: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/datarecord";
    }

    all(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/all", data);
    }

    info(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot, data);
    }

    create(id: any, data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/", data);
    }

    update(id: string, data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/" + id, data);
    }

    download(data: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/" + data.id, data);
    }
}

angular.module("vcServices").service("DataRecordService", DataRecordService);
